import { render } from "./BrandPage.vue?vue&type=template&id=252be8d6&lang=pug"
import script from "./BrandPage.vue?vue&type=script&lang=js"
export * from "./BrandPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__